import { SET_AWS_CREDENTIALS, CLEAR_AWS_CREDENTIALS } from './awsAuthActionTypes';
import { encryptData } from '../utils/cryptoUtils';
import { fetchAwsAuthCredentials as fetchAwsAuthCredentialsApi } from '../utils/awsAuthApiService'; // Corrected path

// Action creator to set AWS credentials (encrypted)
export const setAwsCredentials = (credentials) => {
  const encryptedCredentials = {
    region: credentials.region,
    accessKeyId: encryptData(credentials.accessKeyId),
    secretAccessKey: encryptData(credentials.secretAccessKey),
  };
  return {
    type: SET_AWS_CREDENTIALS,
    payload: encryptedCredentials,
  };
};

// Action creator to clear AWS credentials
export const clearAwsCredentials = () => ({
  type: CLEAR_AWS_CREDENTIALS,
});

// Thunk action creator to fetch and set AWS credentials
export const fetchAndSetAwsCredentials = () => async (dispatch) => {
  try {
    const credentials = await fetchAwsAuthCredentialsApi(); // Expected: { region, accessKeyId, secretAccessKey }
    if (credentials && credentials.accessKeyId && credentials.secretAccessKey && credentials.region) {
      dispatch(setAwsCredentials(credentials)); // This action already handles encryption
    } else {
      console.error('Received incomplete AWS credentials from API.');
      // Optionally dispatch an error action here
    }
  } catch (error) {
    console.error('Failed to fetch and set AWS credentials:', error);
    // Optionally dispatch an error action here
    // dispatch(awsAuthError(error.message)); 
  }
};
